<template>
    <v-card class="elevation-4" style="border-radius: 12px; overflow: hidden;">
        <v-card-title class="headline primary gradient-primary white--text"
            style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
            <div class="header-left">
                <v-avatar size="32" color="white" class="mr-4">
                    <v-icon color="primary" size="24">mdi-file-upload</v-icon>
                </v-avatar>
                <span>Importación de Contratos Previos</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')" color="white">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-container fluid class="pa-3">
            <v-row dense justify="center">
                <v-col cols="12" md="10" lg="8">
                    <v-card outlined class="pa-3 rounded-xl"
                        style="border: 2px dashed #1976d2; background-color: #f5f9ff;">
                        <div class="text-center">
                            <h3 class="">Importar Carga Masiva de Contratos Previos</h3>
                            <p class="grey--text text--base">Cargue el archivo aquí</p>
                        </div>
                        <div>
                            <v-file-input v-model="excelFile" label="Seleccionar archivo Excel para cargar"
                                accept=".xlsx,.xls" @change="handleFileSelect" small-chips show-size
                                prepend-icon="mdi-file-upload"></v-file-input>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <v-card class="rounded-xl" v-if="rowsData.length > 0">
                <v-card-title class="pa-1">
                    <v-icon color="primary" class="mr-2">mdi-table-eye</v-icon>
                    <span class="text-h6 font-weight-medium">Vista Previa de Datos</span>
                    <v-spacer></v-spacer>
                    <v-chip color="info" outlined small>
                        {{ rowsData.length }} registros
                    </v-chip>
                </v-card-title>

                <v-card-text class="pa-0">
                    <v-data-table :headers.async="headersTablePreview" :items="rowsData" height="250"
                        :items-per-page="10" class="elevation-0" loading-text="Cargando datos..."
                        :loading="loadingImport">

                        <template v-slot:item.FUNCIONES="row">
                            <v-btn small color="primary" class="text-none rounded-lg"
                                @click="openModalFunctions(row.item)" :loading="savingData" :disabled="savingData">
                                <v-icon left>mdi-file-document</v-icon>
                                Ver Funciones
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>

            <v-card-text class="d-flex justify-end pa-0 pt-2" v-if="rowsData.length > 0">
                <v-btn medium outlined color="grey darken-1 uppercase" class="mr-3 rounded-lg text-none"
                    @click="$emit('close')">
                    <v-icon left>mdi-close</v-icon>
                    Cancelar
                </v-btn>
                <v-btn medium color="success" class="text-none rounded-lg uppercase" @click="saveDataExcel()"
                    :loading="savingData" :disabled="savingData">
                    <v-icon left>mdi-content-save</v-icon>
                    Guardar
                </v-btn>
            </v-card-text>
        </v-container>

        <!-- Modal anidado para seleccionar Tipo Cultivo -->
        <v-dialog v-model="showFunctionsModal" persistent width="900">
            <v-card class="elevation-5" style="border-radius: 12px; overflow: hidden;">
                <v-card-title class="headline primary gradient-primary white--text"
                    style="background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);">
                    <div class="header-left">
                        <v-avatar size="32" color="white" class="mr-4">
                            <v-icon color="primary" size="24">mdi-file-document</v-icon>
                        </v-avatar>
                        <span>Funciones del Contrato</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="showFunctionsModal = false" color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <template v-if="form">
                    <v-card-text>
                        <div v-html="formatList(form.FUNCIONES)"></div>
                    </v-card-text>
                </template>
            </v-card>
        </v-dialog>

        <AlertSunshine :dialog="loadingImport" />
    </v-card>
</template>

<script>

import _service from "@/services/HumanResource/PreviousContractService";

export default {
    components: {},
    name: "PreviousContractImportModal",
    props: {},
    data() {
        return {
            excelFile: null,
            headersTablePreview: [],
            rowsData: [],
            loadingImport: false,
            savingData: false,
            showFunctionsModal: false,
            form: null,
        };
    },
    methods: {
        async handleFileSelect(value) {
            this.loadingImport = true;
            this.headersTablePreview = [];
            this.rowsData = [];
            if (!this.excelFile) {
                this.loadingImport = false;
                return;
            }

            try {
                const ExcelJS = require("exceljs");
                const reader = new FileReader();
                const workbook = new ExcelJS.Workbook();

                reader.onload = async (e) => {
                    const buffer = e.target.result;
                    await workbook.xlsx.load(buffer);
                    // Primera hoja
                    const worksheet = workbook.worksheets[1];
                    let headers = [];
                    let headersTablePreview = [];
                    let jsonData = [];

                    // Obtener cabeceras (fila 1)
                    worksheet.getRow(1).eachCell((cell, colNumber) => {
                        headers[colNumber] = this.toUpper(cell.value);
                    });

                    // Recorrer filas (desde la fila 2)
                    worksheet.eachRow((row, rowNumber) => {
                        if (rowNumber === 1) return;
                        let rowData = {};

                        row.eachCell((cell, colNumber) => {
                            const header = headers[colNumber];
                            rowData[header] = typeof cell.value === 'object' ? this.toUpper(cell.value?.result) : this.toUpper(cell.value);
                            headersTablePreview.push({
                                text: header,
                                value: header,
                                align: "center",
                                sortable: false,
                                width: ["apellidos y nombres", "direccion", "montoletra", "campaña", "ocupacion", "cargo del jefe"].includes(this.toLower(header)) ? 200 : 120
                            });
                        });

                        jsonData.push(rowData);
                    });
                    this.headersTablePreview = headersTablePreview;
                    this.rowsData = jsonData;
                }
                reader.readAsArrayBuffer(this.excelFile);
                this.loadingImport = false;

            } catch (error) {
                this.$fun.alert("Error al procesar el archivo Excel", "error");
            }
        },
        getValue(value) {
            let rawValue = value;
            if (rawValue) {
                if (!isNaN(rawValue)) {
                    // Si es número (formato Excel), corregimos la conversión restando 25568
                    rawValue = this.$moment(new Date((rawValue - 25568) * 86400 * 1000)).format("YYYY-MM-DD");
                } else {
                    // Si ya es un string, dejarlo tal cual
                    rawValue = this.$moment(rawValue, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                }
            } else {
                rawValue = null;
            }
            return rawValue;
        },
        openModalFunctions(row) {
            this.form = { ...row };
            this.showFunctionsModal = true;
        },
        formatList(text) {
            if (!text) return '';
            const items = text.split('•').map(i => i.trim()).filter(i => i.length);

            return `<ul class="v-list v-list--dense pa-0 ma-0">
                ${items.map(i => `
                <li class="v-list-item pa-0 ma-0 text-left" style="font-size: 10px;">
                   ${i}
                </li>`).join('')}
            </ul>`;
        },
        saveDataExcel() {
            this.savingData = true;
            // console.log(this.rowsData)
            const list = this.rowsData.map(x => {
                return {
                    PrvcID: 0,
                    Document: x.DNI,
                    Name: x["APELLIDOS Y NOMBRES"],
                    Address: x["DIRECCION"],
                    District: x["DISTRITO"],
                    Province: x["PROVINCIA"],
                    Department: x["DPTO"],
                    Campaign: x["CAMPAÑA"],
                    CampaignStartDate: this.getValue(x["FECHA INICIO DE CAMPAÑA"]),
                    CampaignEndDate: this.getValue(x["FECHA FIN DE CAMPAÑA"]),
                    FromDate: this.getValue(x["DESDE"]),
                    ToDate: this.getValue(x["HASTA"]),
                    Amount: x["MONTO"],
                    AmountInWords: x["MONTOLETRA"],
                    Occupation: x["OCUPACION"],
                    SupervisorPosition: x["CARGO DEL JEFE"],
                    Area: x["AREA"],
                    Management: x["GERENCIA"],
                    Functions: x["FUNCIONES"],
                    Day: x["DIA"],
                    Month: x["MES"],
                    SecStatus: 1,
                    UsrCreateID: this.$fun.getUserID()
                }
            })
            // console.log(list)

            _service.save(list, this.$fun.getUserID()).then((res) => {
                this.savingData = false;
                console.log(res)
                if (res.status == 200) {
                    this.$fun.alert("Datos guardados correctamente", "success");
                    this.$emit("close");
                } else {
                    this.$fun.alert("Error al guardar datos", "error");
                }
            }).catch((err) => {
                this.savingData = false;
                console.log(err)
                this.$fun.alert("Error al guardar los datos", "error");
            }).finally(() => {
                this.savingData = false;
            });
        },
        toUpper(value) {
            if (!value) return '';
            if (typeof value === 'object') return '';
            if (value == "" || value == null || value == undefined) return '';
            if (typeof value === 'string') return value.trim().toUpperCase();
            return value;
        },
        toLower(value) {
            if (!value) return '';
            if (typeof value === 'object') return '';
            if (value == "" || value == null || value == undefined) return '';
            if (typeof value === 'string') return value.trim().toLowerCase();
            return value;
        }
    }
};
</script>